<template>
  <div class="city-select">
    <van-actionsheet v-model="isShow" :close-on-click-overlay="false">
      <section class="select-wrap">
        <div class="header">
          <div>{{TLang('选择城市', 'address')}}</div>
          <div class="close" @click="offPopup"></div>
        </div>
        <div class="serch-wrap">
          <form action="/">
            <van-search
              class="search-input"
              v-model="cityValue"
              :placeholder="TLang('请输入城市名称', 'address')"
              @focus="onFocus"
              @blur="onBlur"
              @input="onInput"
            >
              <!-- <div slot="action" @click="onCancel">{{TLang('取消', 'card')}}</div> -->
              <img slot="left-icon" src="../assets/imgs/icon_search.png" class="search-icon" />
            </van-search>
            <div class="search-list" v-show="searchflag">
              <ul class="city-list">
                <li
                  v-for="(item, key) in searchCityData"
                  :key="key"
                  :index="key"
                >
                  <p class="city-letter" :id="'searchCity' + key">{{ key ? key.toUpperCase(): '' }}</p>
                  <ul class="city-name-list">
                    <li
                      class="city-name"
                      :class="isEn ? 'en' : ''"
                      v-for="it in item"
                      @click="cityChange(it)"
                      :key="it.name"
                      :title="isEn ? it.pinyin : it.name"
                    >{{ isEn ? it.pinyin : it.name }}</li>
                  </ul>
                </li>
              </ul>
              <div class="nav-bar">
                <ul class="nav-list">
                  <li
                    v-for="(item, key) in searchCityData"
                    :key="key"
                    :index="key"
                  >
                    <a @click="changeHash('searchCity'+ key)">{{ key ? key.toUpperCase(): '' }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </form>
        </div>

        <div>
          <div class="scroll-part">
            <div
              v-if="locationCityName"
              class="container-module container-location"
            >
              <!-- <van-icon name="location-o"></van-icon> -->
              <span>{{ TLang('定位城市', 'address') }}</span>
              <div class="locate-fail" v-if="!isGetIpAddress">{{ TLang('定位失败', 'address') }}</div>
              <div
                v-else
                class="locate-city"
                @click="
                  cityChange({ cityId: positionAddress.city.id, name: positionAddress.city.nameCh })
                "
              >
                {{ isEn ? (positionAddress.city.nameEn || positionAddress.city.nameCh) : positionAddress.city.nameCh }}
              </div>
            </div>
            <div class="part">
              <p class="city_title">{{ TLang('最近访问城市', 'address') }}</p>

              <div class="always-city">
                <template v-for="(i, index) in HisData">
                  <div
                    :key="index"
                    :class="[{ en: isEn }, 'always']"
                    @click="cityChange(i)"
                  >{{ isEn ? i.pinyin : i.name || i.nameCh  }}</div>
                </template>
              </div>
            </div>

            <div class="part">
              <p id="hot" class="top-20 city_title">{{ TLang('热门城市', 'address') }}</p>

              <div class="always-city">
                <template v-for="(i, index) in Hcity">
                  <div
                    :key="index"
                    :class="[{ en: isEn }, 'always']"
                    @click="cityChange(i)"
                  >{{ isEn ? i.pinyin : i.name || i.nameCh }}</div>
                </template>
              </div>
            </div>
            <ul class="city-list">
              <li
                v-for="(item, key) in resolveCityData"
                :key="key"
                :index="key"
              >
                <p class="city-letter" :id="'city' + key">{{ key ? key.toUpperCase(): '' }}</p>
                <ul class="city-name-list">
                  <li
                    class="city-name"
                    :class="isEn ? 'en' : ''"
                    v-for="it in item"
                    @click="cityChange(it)"
                    :key="it.name"
                    :title="isEn ? it.pinyin : it.name"
                  >{{ isEn ? it.pinyin : it.name }}</li>
                </ul>
              </li>
            </ul>
            <div class="nav-bar">
              <ul class="nav-list">
                <li><a @click="changeHash('hot')">{{ TLang('热', 'address') }}</a></li>
                <li
                  v-for="(item, key) in resolveCityData"
                  :key="key"
                  :index="key"
                >
                  <a @click="changeHash('city'+ key)">{{ key ? key.toUpperCase(): '' }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </van-actionsheet>
  </div>
</template>

<script>
import {
  unionFlag,
  getCookieAddressInfo,
  checkUnifyShop,
} from "../utils";
import { publicFunc } from "../utils/func";
import { setCatchAddress } from 'dflocationsdk';
import { getAddress } from '../utils/locationApi/location';
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    isGetIpAddress: {
      type: Boolean,
      default: false,
    },
    positionAddress: Object,
    Hcity: Array,
    Cdata: Array,
    HisData: Array,
  },
  data() {
    return {
      cityValue: "",
      searchflag: false,
      searchCityData: {},
      showAction: false,
      locationCityName: getCookieAddressInfo('cityName') || '',
      locationCityPinyin: getCookieAddressInfo('cityNameValue') || '',
      locationCityId: getCookieAddressInfo('cityId') || '',
      isEn: this.getDFLANG(),
    };
  },
  watch: {
    cityValue(newValue) {
      if (newValue === "") {
        this.searchflag = false;
        this.searchCityData = {};
      } else {
        this.searchflag = true;
        this.searchCityData = {};
        let newArr = this.Cdata.filter(
          (cities) =>
            cities.pinyin
              .toLowerCase()
              .indexOf(this.cityValue.toLowerCase()) !== -1 ||
            cities.name.indexOf(this.cityValue) !== -1
        );
        if (newArr && newArr.length > 0) {
          newArr.forEach((cities) => {
            let key = cities.first;
            if (this.searchCityData[key] == undefined) {
              this.searchCityData[key] = new Array();
            }
            this.searchCityData[key].push(cities);
          });
        }
      }
    },
  },
  computed: {
    resolveCityData() {
      let ob = {};
      if (this.Cdata && this.Cdata.length > 0) {
        this.Cdata.forEach((cities) => {
          let key = cities.first;
          if (ob[key] == undefined) {
            ob[key] = new Array();
          }
          ob[key].push(cities);
        });
      }
      return ob;
    },
  },
  methods: {
    changeHash(idName) {
      document.getElementById(idName).scrollIntoView();
    },
    getDFLANG() {
      const union = unionFlag() || sessionStorage.getItem("dffl_union");
      return publicFunc.getCookie("df_lang") == "en-US" && (union || checkUnifyShop());
    },
    /**
     * 日期格式化
     * @param { String } time 日期
     */
    transformDate(time) {
      if (time) {
        const date = new Date(time);
        const year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        month = month < 10 ? "0" + month : month;
        day = day < 10 ? "0" + day : day;
        return year + "-" + month + "-" + day;
      }
    },
    onCancel() {
      this.cityValue = '';
    },
    onFocus() {
      this.showAction = true;
    },
    onBlur() {
      this.showAction = false;
    },
    onInput(e) {
      console.log(e);
    },
    offPopup() {
      this.cityValue = '';
      this.$emit("closePops");
    },
    cityChange(item) {
      let cityId =  this.locationCityId;
      if (cityId == item.id || cityId == item.cityId) {
        this.offPopup();
      } else {
        this.getNewAddress(item.cityId || item.id)
      }
    },
    // 获取用户新四级地址
    async getNewAddress(cityId) {
      const addressRes = await getAddress(cityId);

      if (addressRes.Data.data) {
        const info = addressRes.Data.data;
        const address = {
          provinceId: info.district && info.district.id,
          provinceName: info.district && info.district.nameCh,
          provinceNameValue: info.district && info.district.nameEn,
          cityName: info.city && info.city.nameCh,
          cityId: info.city && info.city.id,
          cityNameValue: info.city && info.city.nameEn,
          regionId: info.region && info.region.id,
          regionName: info.region && info.region.nameCh,
          regionNameValue: info.region && info.region.nameEn,
          streetId: info.streetList && info.streetList.length && info.streetList[0].id || null,
          streetName: info.streetList && info.streetList.length && info.streetList[0].nameCh,
          streetNameValue: info.streetList && info.streetList.length && info.streetList[0].nameEn,
        };
        setCatchAddress(
          address.provinceId,
          address.provinceName,
          address.provinceNameValue,
          address.cityId,
          address.cityName,
          address.cityNameValue,
          address.regionId,
          address.regionName,
          address.regionNameValue,
          address.streetId,
          address.streetName,
          address.streetNameValue,
          '',
        )
        this.$emit("handleReload");
      }
    },
  },
};
</script>

<style lang="less" scoped>
@375: 320/375;
.city-select {
  .van-popup {
    border-radius: 12px * @375 12px * @375 0px * @375 0px * @375;
    // padding: 12px * @375;
    box-sizing: border-box;
    height: 85vh;
    overflow-y: hidden;
    z-index: 9999 !important;
  }
  /deep/ .van-overlay {
    z-index: 9998 !important;
  }
  .van-actionsheet__content {
    position: relative;
  }
  // /deep/ .mint-indexsection-index {
  //   background: #fff;
  // }
  /deep/ .van-field__control {
    line-height: 24px * @375;
    font-size: 14px * @375;
  }
  /deep/ .en .van-cell__title span {
    font-family: system-ui, -apple-system, Arial, sans-serif;
  }
  .search-icon {
    display: block;
    width: 12px * @375;
    height: 12px * @375;
  }
  .city_title {
    font-size: 12 * @375;
    line-height: 18px * @375;
    margin-bottom: 5px * @375;
    padding: 0;
    color: #999;
  }
  .container-location {
    padding: 6px * @375;
    font-size: 14px * @375;
    color: #999;
    margin-bottom: 15px * @375;
  }

  .container-module {
    position: relative;
    padding: 0 15px * @375;
  }
  .container-location > span {
    display: block;
    height: 18px * @375;
    font-size: 12px * @375;
    color: #999;
    line-height: 18px * @375;
    margin-bottom: 5px * @375;
  }
  .container-location > .locate-fail {
    display: inline-block;
    width: auto;
    min-width: 104px * @375;
    box-sizing: border-box;
    padding: 0 8px * @375;
    max-width: 100%;
    text-align: center;
    height: 32px * @375;
    line-height: 32px * @375;
    border: 1px solid #e5e5e5;
    border-radius: 4px * @375;
    color: #333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .container-location > .locate-city {
    display: inline-block;
    width: auto;
    min-width: 104px * @375;
    box-sizing: border-box;
    padding: 0 8px * @375;
    max-width: 100%;
    text-align: center;
    height: 32px * @375;
    line-height: 32px * @375;
    border: 1px solid #3FA6FF;
    border-radius: 4px * @375;
    color: #3FA6FF;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .select-wrap {
    // width: 100vw;
    // height: 100vh;
    background: #fff;
    text-align: left;
    .header {
      height: 55px * @375;
      text-align: center;
      position: relative;
      font-size: 16px * @375;
      font-weight: 400;
      color: #333333;
      line-height: 55px * @375;
      .close {
        position: absolute;
        top: 15px * @375;
        right: 15px * @375;
        width: 18px * @375;
        height: 18px * @375;
        background: url('../assets/imgs/add_cart_close.png') center center no-repeat;
        background-size: 100% auto;
      }
    }

    .van-search__content {
      padding-left: 11px * @375;
      height: 32px * @375;
      border-radius: 16px * @375;
      font-size: 14px * @375;

      .van-field__body {
        .van-field__control {
          font-size: 14px * @375;
        }
      }
    }
    .van-search {
      .van-cell {
        align-items: center;
        .van-field__left-icon {
          margin-right: 5px * @375;
        }
      }
    }
    .van-search__action {
      font-size: 14px * @375;
      color: #3FA6FF;
      line-height: 32px * @375;
      padding-left: 15px * @375;
      padding-right: 0;
    }
    // /deep/ .mint-indexlist-content {
    //   margin-right: 0 !important;
    //   // padding-right: 23px * @375;
    // }
    // /deep/ .mint-indexlist-nav {
    //   border-left: none;
    //   background: transparent;
    // }
    .search-input {
      position: relative;
      z-index: 100;
      padding: 0px * @375 15px * @375 10px * @375;
      background: #fff !important;
      border-bottom: 1px solid #e5e5e5;
    }
    .search-list {
      // padding-top: 104px * @375;
      height: calc(85vh - 98px * @375);
      position: absolute;
      box-sizing: border-box;
      // top: 0;
      left: 0;
      // bottom: 0;
      right: 0;
      width: 100%;
      z-index: 100;
      background: #fff;
      overflow-y: auto;
      .nav-bar {
        position: fixed;
        height: calc(85vh - 98px * @375);
        right: 0;
        top: 98px * @375;
        display: flex;
        align-items: center;
        overflow-y: auto;
      }
    }
    .hot-city {
      padding: 0.2222rem /* 24/108 */ 0.1852rem /* 20/108 */;
      padding-top: 0;
      background: #f5f5f5;
      .hot-city-cell {
        float: left;
        width: 30%;
        line-height: 0.8333rem /* 90/108 */;
        text-align: center;
        margin-right: 0.1852rem /* 20/108 */;
        margin-bottom: 0.2222rem /* 24/108 */;
        border: 1px * @375 solid #e3e3e3;
        background: #fff;
        font-size: 16px * @375;
        &.active {
          border-color: #fcca7e;
        }
        &.current-place i {
          color: #fcca7e;
          margin-left: -8px * @375;
        }
      }
    }
    .search-back {
      position: absolute;
      top: 18px * @375;
      padding: 0 7px * @375;
      font-size: 18px * @375;
      color: #333;
      z-index: 9999999;
    }

    .curr-city {
      line-height: 40px * @375;
      background: #ffffff;
      color: #333333;
      font-size: 14px * @375;
      padding-left: 16px * @375;
    }
    .scroll-part {
      padding-top: 15px * @375;
      height: calc(85vh - 98px * @375);
      box-sizing: border-box;
      overflow-y: auto;
      position: relative;
      .nav-bar {
        position: fixed;
        height: calc(85vh - 98px * @375);
        right: 0;
        top: 98px * @375;
        display: flex;
        align-items: center;
        overflow-y: auto;
      }
    }
    .part {
      padding-left: 15px * @375;
      margin-bottom: 5px * @375;

      .always-city {
        display: flex;
        flex-wrap: wrap;
      }

      .always {
        width: 104px * @375;
        height: 32px * @375;
        line-height: 32px * @375;
        box-sizing: border-box;
        text-align: center;
        color: #333;
        border: none;
        background: #fff;
        margin-bottom: 10px * @375;
        font-size: 14px * @375;
        margin-right: 10px * @375;
        border: 1px * @375 solid #e4e4e4;
        border-radius: 4px * @375;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &:nth-of-type(3n) {
          margin-right: 0;
        }
        span {
          margin-left: 6px * @375;
        }
      }

      .local {
        color: #496aac;
        border: 1px * @375 solid #496aac;
      }
    }
    .city-list {
      .city-letter {
        height: 30px * @375;
        line-height: 30px * @375;
        padding-left: 15px * @375;
        font-size: 12px * @375;
        background: #fff;
        color: #999;
        border-bottom: 1px solid #f7f7f7;
      }
      .city-name-list {
        background: #fff;
        padding: 0 15px * @375;
        .city-name {
          padding: 5px * @375 0;
          // height: 24px * @375;
          font-size: 14px * @375;
          line-height: 24px * @375;
          // border-bottom: 1px * @375 solid #e4e4e4;
          color: #333;
          // &:last-child {
          //   border-bottom: none;
          // }
        }
      }
    }
    ul.nav-list {
      height: auto;
      max-height: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 23px * @375;
      li {
        display: block;
        width: 100%;
        text-align: center;
        height: 16px * @375;
        line-height: 16px * @375;
        font-size: 12px * @375;
        a {
          color: #666;
          display: block;
          height: 16px * @375;
          width: 16px * @375;
          line-height: 16px * @375;
          text-align: center;
          border-radius: 8px * @375;
          background: transparent;
          margin-right: 0;
          &:active {
            color: #fff;
            background: #3FA6FF;
          }
        }
      }
    }
  }
}
</style>
